import { createFileRoute } from '@tanstack/react-router';
import { TonguePage } from '../components/scan/TonguePage.tsx';

export const Route = createFileRoute('/_app/scan/tongue')({
  component: TonguePage,
});
